import { create } from 'zustand';
import { ApiUtils, ApplicationApi, type ApplicationPdfRequest } from '@shared/api';

interface UseApplicationPdfStore {
  loading: boolean;
  data: Blob | null;
  error: string | null;
  getApplicationPdf: (request: ApplicationPdfRequest, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useApplicationPdfStore = create<UseApplicationPdfStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  getApplicationPdf: async (request, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await ApplicationApi.getPdf(request, signal);
      set({ loading: false, data: result || null });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  },

  clear: () => set({ loading: false, data: null, error: null }),
}));
